<script lang="ts">
	import type { MarkdownOptions } from '@magidoc/plugin-svelte-marked';
	import type { Renderers } from '@magidoc/plugin-svelte-marked';
	import { BaseParagraph, type BaseParagraphProps } from '../BaseParagraph';

	interface Props {
		token: BaseParagraphProps['token'];
		options: MarkdownOptions | undefined;
		renderers: Renderers | undefined;
	}

	let { token, options, renderers }: Props = $props();
</script>

<BaseParagraph
	variant="body3"
	boldVariant="label4"
	class="text-gray-500"
	{token}
	{options}
	{renderers}
/>
